import { StationsList } from "../data/MenuData"

export default function StationTitle({station}) {
    const StationName = StationsList.find(item => item.code === station);
    return StationName && (
        <div className="station-title">
            <p><span>•</span> LIVE</p>
            <h2>Stacja <span style={{textTransform: 'capitalize'}}>{StationName.name}</span></h2>
        </div>
    )
}